// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-TabsMenuItem {
  background: transparent;
  transition: color 0.2 ease;
  font-weight: 600;
  white-space: nowrap;
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid var(--color-border-base);
}
.n-TabsMenuItem.n--selected {
  border: none;
}
.n-TabsMenuItem--square.n-TabsMenuItem--sm {
  width: 24px;
}
.n-TabsMenuItem--square.n-TabsMenuItem--md {
  width: 32px;
}
.n-TabsMenuItem--square.n-TabsMenuItem--lg {
  width: 40px;
}
.n-TabsMenuItem--sm {
  font-size: 12px;
  height: 24px;
  padding: 0 8px;
}
.n-TabsMenuItem--md {
  font-size: 14px;
  height: 32px;
  padding: 0 16px;
}
.n-TabsMenuItem--lg {
  font-size: 16px;
  height: 40px;
  padding: 0 24px;
}
.n-TabsMenuItem--vertical {
  padding: 0 8px;
}
.n-TabsMenuItem--radius-xs {
  border-radius: 4px;
}
.n-TabsMenuItem--radius-sm {
  border-radius: 8px;
}
.n-TabsMenuItem:hover {
  text-decoration: none;
}
.n-TabsMenuItem--variant-light.n--clickable {
  color: var(--color-content-base);
}
.n-TabsMenuItem--variant-light.n--clickable:hover {
  background: var(--color-neutral-background-hover);
}
.n-TabsMenuItem--variant-light.n--clickable:active {
  background: var(--color-accent-subtle-background-base);
  color: var(--color-accent-content-contrast);
}
.n-TabsMenuItem--variant-light.n-TabsMenuItem__icon {
  color: var(--color-icon-base);
}
.n-TabsMenuItem--variant-light.n--disabled {
  color: var(--color-content-secondary);
  opacity: 50%;
}
.n-TabsMenuItem--variant-light.n--selected,
.n-TabsMenuItem--variant-light.n--selected:hover,
.n-TabsMenuItem--variant-light.n--selected:active {
  background: var(--color-accent-subtle-background-base);
  color: var(--color-accent-content-contrast);
}
.n-TabsMenuItem--variant-light.n--selected .n-TabsMenuItem__icon {
  color: var(--color-accent-content-contrast);
}
.n-TabsMenuItem--variant-dark.n--clickable {
  color: #d2d5d7;
}
.n-TabsMenuItem--variant-dark.n--clickable:hover {
  color: #d2d5d7;
}
.n-TabsMenuItem--variant-dark.n--clickable:hover .n-TabsMenuItem__icon {
  color: #d2d5d7;
}
.n-TabsMenuItem--variant-dark.n-TabsMenuItem__icon {
  color: #d2d5d7;
}
.n-TabsMenuItem--variant-dark.n--disabled {
  color: #202223;
  opacity: 50%;
}
.n-TabsMenuItem--variant-dark.n--selected,
.n-TabsMenuItem--variant-dark.n--selected:hover,
.n-TabsMenuItem--variant-dark.n--selected:active {
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/tabs-menu-item/TabsMenuItem.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,uBAAA;EACA,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0CAAA;AASF;AAPE;EACE,YAAA;AASJ;AANE;EACE,WAAA;AAQJ;AALE;EACE,WAAA;AAOJ;AAJE;EACE,WAAA;AAMJ;AAHE;EACE,eAAA;EACA,YAAA;EACA,cAAA;AAKJ;AAFE;EACE,eAAA;EACA,YAAA;EACA,eAAA;AAIJ;AADE;EACE,eAAA;EACA,YAAA;EACA,eAAA;AAGJ;AAAE;EACE,cAAA;AAEJ;AACE;EACE,kBAAA;AACJ;AAEE;EACE,kBAAA;AAAJ;AAGE;EAEE,qBAAA;AAFJ;AAKE;EACE,gCAAA;AAHJ;AAKI;EACE,iDAAA;AAHN;AAMI;EACE,sDAAA;EACA,2CAAA;AAJN;AAQE;EACE,6BAAA;AANJ;AASE;EACE,qCAAA;EAEA,YAAA;AARJ;AAYI;;;EAGE,sDAAA;EACA,2CAAA;AAVN;AAKE;EASI,2CAAA;AAXN;AAmBE;EACE,cAAA;AAjBJ;AAmBI;EACE,cAAA;AAjBN;AAgBI;EAGI,cAAA;AAhBR;AAqBE;EACE,cAAA;AAnBJ;AAsBE;EACE,cAAA;EAEA,YAAA;AArBJ;AAyBI;;;EAGE,WAAA;AAvBN","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.n-TabsMenuItem {\n  background: transparent;\n  transition: @color-transition;\n  font-weight: @fontWeight-semibold;\n  white-space: nowrap;\n  text-decoration: none;\n  user-select: none;\n  border: @box-border;\n\n  &.n--selected {\n    border: none;\n  }\n\n  &--square&--sm {\n    width: @layoutUnit-lg;\n  }\n\n  &--square&--md {\n    width: @layoutUnit-xl;\n  }\n\n  &--square&--lg {\n    width: @layoutUnit-xxl;\n  }\n\n  &--sm {\n    font-size: @fontSize-xs;\n    height: @layoutUnit-lg;\n    padding: 0 @layoutUnit-sm;\n  }\n\n  &--md {\n    font-size: @fontSize-sm;\n    height: @layoutUnit-xl;\n    padding: 0 @layoutUnit-md;\n  }\n\n  &--lg {\n    font-size: @fontSize-base;\n    height: @layoutUnit-xxl;\n    padding: 0 @layoutUnit-lg;\n  }\n\n  &--vertical {\n    padding: 0 @layoutUnit-sm;\n  }\n\n  &--radius-xs {\n    border-radius: @layoutUnit-xs;\n  }\n\n  &--radius-sm {\n    border-radius: @layoutUnit-sm;\n  }\n\n  &:hover {\n    // Disable decoration on any link component\n    text-decoration: none;\n  }\n\n  &--variant-light.n--clickable{\n    color: var(--color-content-base);\n\n    &:hover {\n      background: var(--color-neutral-background-hover);\n    }\n\n    &:active {\n      background: var(--color-accent-subtle-background-base);\n      color: var(--color-accent-content-contrast);\n    }\n  }\n\n  &--variant-light&__icon {\n    color: var(--color-icon-base);\n  }\n\n  &--variant-light.n--disabled {\n    color: var(--color-content-secondary);\n\n    opacity: 50%;\n  }\n\n  &--variant-light.n--selected {\n    &,\n    &:hover,\n    &:active {\n      background: var(--color-accent-subtle-background-base);\n      color: var(--color-accent-content-contrast);\n    }\n\n    .n-TabsMenuItem__icon {\n      color: var(--color-accent-content-contrast);\n    }\n  }\n\n  @color--white: #fff;\n  @color--grey-95: #d2d5d7;\n  @color--grey-100: #202223;\n\n  &--variant-dark.n--clickable{\n    color: @color--grey-95;\n\n    &:hover {\n      color: @color--grey-95;\n      .n-TabsMenuItem__icon {\n        color: @color--grey-95;\n      }\n    }\n  }\n\n  &--variant-dark&__icon {\n    color: @color--grey-95;\n  }\n\n  &--variant-dark.n--disabled {\n    color: @color--grey-100;\n\n    opacity: 50%;\n  }\n\n  &--variant-dark.n--selected {\n    &,\n    &:hover,\n    &:active {\n      color: @color--white;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
